import { useDispatch } from 'react-redux';
import { resetDealerships } from '@makemydeal/dr-activities-dealership-picker';
import { BannerContainer, BannerText } from './ViewAsBanner.style';
import { useRoleAssumptionSelector } from '../../selectors';
import { middlewareMgr } from '../../store';
import { extractQueryParams } from '../../utils/queryUtils';

//interstate components
import { Button } from '@interstate/components/Button';
import { useLocation } from 'react-router-dom';

export const ViewAsBanner = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    // Extract specific query parameters using utility function
    const queryString = extractQueryParams(location.search);

    const { assumedUserName, isRoleAssumptionStarted } = useRoleAssumptionSelector();
    const onStopRoleAssumption = () => {
        // Logic to stop roleAssumption goes here
        if (middlewareMgr?.hostActions) {
            // Only dispatch clearRoleAssumption - the middleware will handle navigation
            dispatch(middlewareMgr.hostActions.clearRoleAssumption(`?${queryString}`));
            dispatch(resetDealerships());
        }
    };

    if (!isRoleAssumptionStarted) {
        return null;
    }
    return (
        <BannerContainer>
            <BannerText>You are viewing as {assumedUserName}</BannerText>
            <Button onClick={onStopRoleAssumption} buttonStyle="primary" data-testid="stop-button" type="button">
                Stop Viewing As
            </Button>
        </BannerContainer>
    );
};

export default ViewAsBanner;
